import * as React from "react";
import Questionnaire from "benchmarking-domain/questionnaire";
import {useCallback, useState} from "react";
import {JsonEditor} from "components/core/json-editor";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import CardContent from "@mui/material/CardContent";
import {Switch} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import {DynamicQuestionnaire} from "benchmarking-domain/dynamic-questionnaire";
import * as DynamicQuestionnaireSchema from "benchmarking-domain/schemas/dynamic-questionnaire.schema.json";

interface DynamicQuestionnaireForm {
  dynamicQuestionnaire?: DynamicQuestionnaire;
  onSubmit: (data: DynamicQuestionnaire) => Promise<void>;
}

export function DynamicQuestionnaireForm({dynamicQuestionnaire, onSubmit}: DynamicQuestionnaireForm): React.JSX.Element {
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [jsonObject, setJsonObject] = useState<{}>({...dynamicQuestionnaire});

  const jsonChangeHandler = useCallback((data: any) => {
    setJsonObject(data);
  }, []);

  const submitChanges = useCallback(async () => {
    setIsSaving(true);
    try {
      await onSubmit(jsonObject as DynamicQuestionnaire);
    } finally {
      setIsSaving(false);
    }
  }, [onSubmit, jsonObject])

  return (
    <Card sx={{overflow: "visible"}}>
      <CardHeader title="Dynamic questionnaire"/>
      <Divider/>
      <CardContent>
        <JsonEditor json={dynamicQuestionnaire} schema={DynamicQuestionnaireSchema} onChangeJson={jsonChangeHandler} />
      </CardContent>
      <Divider/>
      <CardActions sx={{justifyContent: 'flex-end'}}>
        <Button onClick={submitChanges} variant="contained" disabled={isSaving}>Save details</Button>
      </CardActions>
    </Card>

  );
}
